module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/073-togo-7696ce48f6ff7eaa84d7d469196715bf.svg";